export class ProfilePreferences {
    showDetailColumnForTimecards: boolean
    showArchivedData: boolean

    static fromJSON(json: any): ProfilePreferences {
        const result: ProfilePreferences = new ProfilePreferences()

        if (json) {
            json = JSON.parse(json)
            Object.assign(result, json)
        }

        return result
    }

    constructor() {
        this.showDetailColumnForTimecards = false
        this.showArchivedData = false
    }
}
